export function isValidMMSINumber(mmsi: string): boolean {
  // Ensure the input is 7-9 digits long and does not start with 0
  return /^[1-9]\d{6,8}$/.test(mmsi);
}
